import { isPlatformBrowser } from "@angular/common";
import { Inject, Injectable, PLATFORM_ID } from "@angular/core";
import { Magic } from "magic-sdk";
import { environment } from "src/environments/environment";

@Injectable({
    providedIn: 'root'
})
export class MagicLinkService {

    private magicSdk: Magic | null = null;

    constructor(
        @Inject(PLATFORM_ID) platformId: object
    ) {
        if (!isPlatformBrowser(platformId)) return;
        this.magicSdk = new Magic(environment.magicLink.API_KEY);
        this.magicSdk.preload().then(() => {
            console.log('Magic <iframe> loaded.');
        }
        );
    }

    logout(){
        if(this.magicSdk && this.magicSdk.user){
            this.magicSdk.user.logout();
          }
    }

    login(data: any) {
                if (!this.magicSdk) {
                    return Promise.reject(new Error('Magic Link is available only in the browser.'));
                }
        if(data.email) {
          return this.magicSdk.auth.loginWithEmailOTP(data);
        } else {
          return this.magicSdk.auth.loginWithSMS(data);
        }
    }
}